import * as api from '../api';

export function confirmCode(params) {
  return api.get('v2/userToken/validateToken', params);
}

export function setUserPassword(body) {
  return api.post('v2/register/password', body);
}
